import React from 'react';
import style from './app-box.module.scss';
import { NarrowAppBoxSkeleton } from './app-box-layouts/narrow-app-box';
import { RegularAppBoxSkeleton } from './app-box-layouts/regular-app-box';
import { WideAppBoxSkeleton } from './app-box-layouts/wide-app-box';
import { SlimAppBoxSkeleton } from './slim-app-box-skeleton';
export function AppBoxSkeleton({ skin = 'default' }) {
    return (React.createElement("div", { className: `${style.appBoxSkeleton} ${skin === 'slim' ? style.skinSlim : style.skinDefault}` }, skin === 'slim' ? (React.createElement(React.Fragment, null,
        React.createElement(SlimAppBoxSkeleton, { className: style.slimLayout }))) : (React.createElement(React.Fragment, null,
        React.createElement(NarrowAppBoxSkeleton, { className: style.narrowLayout }),
        React.createElement(RegularAppBoxSkeleton, { className: style.regularLayout }),
        React.createElement(WideAppBoxSkeleton, { className: style.wideLayout })))));
}
//# sourceMappingURL=app-box-skeleton.js.map